import { NgModule } from '@angular/core';
import { PreloadAllModules, NoPreloading, RouterModule, Routes } from '@angular/router';
import { OktaCallbackComponent } from '@okta/okta-angular';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { ManagecustomerComponent } from './components/managecustomer/managecustomer.component';
import { NotfoundComponent } from './components/notfound/notfound.component';
import { RegistrationComponent } from './components/registration/registration.component';
import { FscHFLayoutComponent } from './core/layout/fschflayout/fschflayout.component';
import { FsclayoutComponent } from './core/layout/fsclayout/fsclayout.component';
import { HomeServiceResolver } from './resolvers/home.resolver';
import { FscAuthGuard } from './services/fscauth.guard';

const routes: Routes = [
  {
    path: "",
    component: LoginComponent,
  },
  {
    path: "login",
    component: LoginComponent,
  },
  {
    path: "authorization-code/callback",
    component: OktaCallbackComponent,
  },
  {
    path: "",
    component: FscHFLayoutComponent,
    canActivate: [FscAuthGuard],
    children: [
      {
        path: "registration",
        component: RegistrationComponent,
        canActivate: [FscAuthGuard],
      },
      {
        path: "managecustomer",
        component: ManagecustomerComponent,
        canActivate: [FscAuthGuard],
      },
      {
        path: "home",
        component: HomeComponent,
        canActivate: [FscAuthGuard],
        resolve: { homeServiceResolver: HomeServiceResolver },
        runGuardsAndResolvers: "paramsOrQueryParamsChange",
        data: { preload: true },
      },
      {
        path: "",
        canActivate: [FscAuthGuard],
        loadChildren: () =>
          import("./components/dashboard/dashboard.module").then(
            (m) => m.DashboardModule
          ),
      },
    ],
    data: { preload: true },
  },
  {
    path: "",
    component: FsclayoutComponent,
    children: [
      {
        path: "",
        canActivate: [FscAuthGuard],
        loadChildren: () =>
          import("./components/operations/operations.module").then(
            (m) => m.OperationsModule
          ),
      },
      {
        path: "",
        canActivate: [FscAuthGuard],
        loadChildren: () =>
          import("./components/administration/administration.module").then(
            (m) => m.AdministrationModule
          ),
      },
      {
        path: "",
        canActivate: [FscAuthGuard],
        loadChildren: () =>
          import("./components/configuration/configuration.module").then(
            (m) => m.ConfigurationModule
          ),
      },
      {
        path: "",
        canActivate: [FscAuthGuard],
        loadChildren: () =>
          import("./components/reverse/reverse.module").then(
            (m) => m.ReverseModule
          ),
      },
      {
        path: "auction-orders",
        canActivate: [FscAuthGuard],
        loadChildren: () =>
          import("./components/auction-orders/auction-orders.modules").then(
            (m) => m.AuctionAOrdersModule
          ),
      },
      {
        path: "inventory",
        canActivate: [FscAuthGuard],
        loadChildren: () =>
          import("./components/inventory/inventory.module").then(
            (m) => m.InventoryModule
          ),
      },
      {
        path: "invoicing",
        canActivate: [FscAuthGuard],
        loadChildren: () =>
          import("./components/invoicing/invoicing.module").then(
            (m) => m.InvoicingModule
          ),
      },
      {
        path: "teammember",
        canActivate: [FscAuthGuard],
        loadChildren: () =>
          import("./components/teammember/teammember.module").then(
            (m) => m.TeammemberModule
          ),
      },
      {
        path: "triage-repair",
        canActivate: [FscAuthGuard],
        loadChildren: () =>
          import("./components/triage-repair/triage-repair.module").then(
            (m) => m.TriageRepairModule
          ),
      },
      {
        path: "flareTechConfig",
        canActivate: [FscAuthGuard],
        loadChildren: () =>
          import("./components/tech-config/tech-config.module").then(
            (m) => m.TechConfigModule
          ),
      },
      {
        path: "qrCode",
        canActivate: [FscAuthGuard],
        loadChildren: () =>
          import("./components/rf-qrcode/rf-qrcode.module").then(
            (m) => m.RFQRCodeModule
          ),
      },
      {
        path: "repairMoveTask",
        canActivate: [FscAuthGuard],
        loadChildren: () =>
          import("./components/move-task/move-task.module").then(
            (m) => m.MoveTaskModule
          ),
      },
      {
        path: "repairMoveTask/:id",
        canActivate: [FscAuthGuard],
        loadChildren: () =>
          import("./components/move-task/move-task.module").then(
            (m) => m.MoveTaskModule
          ),
      }
    ],
  },
  {
    path: "access-denied",
    component: NotfoundComponent,
  },
  {
    path: "**",
    component: NotfoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    {
    onSameUrlNavigation: 'reload',
    scrollPositionRestoration: 'enabled',
    preloadingStrategy: NoPreloading,
    relativeLinkResolution: 'legacy'
})],

  exports: [RouterModule]
})
export class AppRoutingModule { }
